import * as React from 'react';
import { Edit, SimpleForm, TextInput, DateInput, SelectInput, required, maxLength, Toolbar, SaveButton, useNotify, useRedirect, FormDataConsumer, ImageInput, ImageField } from 'react-admin';
import { OFFER_LINK_CHOICES } from './offerLinkChoices';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useAuthorize from '../hooks/useAuthorize';
import { MARKETING_CONTENT_ROLES } from '../roles/portalRoles';

const CustomToolbar = () => {
    const redirect = useRedirect();

    const handleBack = () => {
        redirect('/offers');
    };

    return (
        <Toolbar>
            <SaveButton />
            <Button color="primary" onClick={handleBack} style={{ marginLeft: '10px' }}>Back</Button>
        </Toolbar>
    );
};

export const OfferEdit = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('resources.offers.notification.updated', {
            type: 'info',
            undoable: true,
            messageArgs: { smart_count: 1, name: 'Offer' }
        });
        redirect('/offers');
    };
    useAuthorize(MARKETING_CONTENT_ROLES);

    const handleSubmit = async (values: any) => {
        try {
            const formData = new FormData();
            formData.append("post", values.post || "");
            formData.append("expirydate", values.expirydate || "");
            formData.append("target_page", values.target_page || "prices");
            
            if (values.target_page === 'external' && values.external_url) {
                formData.append("external_url", values.external_url);
            }

            if (values.image_file && values.image_file.rawFile) {
                formData.append("image_file", values.image_file.rawFile);
            }

            const token = localStorage.getItem("user_authToken");
            const response = await fetch(process.env.REACT_APP_API_URL + "/offers/" + values.id, {
                method: "PUT",
                body: formData,
                headers: token ? { Authorization: `Bearer ${token}` } : undefined,
            });

            if (!response.ok) {
                throw new Error("Failed to update offer");
            }

            onSuccess();
        } catch (error) {
            console.error("Error updating offer:", error);
            notify("Error updating offer", { type: "error" });
        }
    };

    return (
        <Edit {...props} mutationOptions={{onSuccess: onSuccess}}>
            <SimpleForm toolbar={<CustomToolbar />} onSubmit={handleSubmit}>
                <TextInput source="post" label="Offer Details" validate={[required(), maxLength(2000)]} fullWidth />
                <DateInput source="expirydate" label="Expiry Date" validate={required()}/>
                <SelectInput
                    source="target_page"
                    label="Banner links to"
                    choices={[...OFFER_LINK_CHOICES]}
                    validate={required()}
                    helperText="Where users go when they tap this banner in the Credco app"
                />
                <FormDataConsumer>
                    {({ formData }) => formData.target_page === 'external' && (
                        <TextInput source="external_url" label="External URL" validate={required()} fullWidth helperText="Example: https://youtube.com/..." />
                    )}
                </FormDataConsumer>
                
                <ImageInput source="image_file" label="Upload Image Banner (Recommended 1200x200)" accept="image/*">
                    <ImageField source="src" title="title" />
                </ImageInput>
                <FormDataConsumer>
                    {({ formData }) => formData.image_banner && !formData.image_file && (
                        <div style={{ margin: '10px 0' }}>
                            <p style={{ margin: '0 0 5px 0', fontSize: '0.75rem', color: 'rgba(0, 0, 0, 0.6)' }}>Current Banner</p>
                            <img src={formData.image_banner} alt="Current Banner" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                        </div>
                    )}
                </FormDataConsumer>
            </SimpleForm>
        </Edit>
    );
};

export default OfferEdit;